module.exports = __webpack_public_path__ + "img/news_1.da5ca901.jpg";